import { useEffect, useState } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { useAuthContext } from "../../hooks";
import { getOrgUserGeneralFaqByOrgUserId } from "../../api/FAQ/UserFaq/getOrgUserGeneralFaqByOrgUserId";
import FaqSc from "./index.sc";
import { useForm } from "react-hook-form";
import { createAnonymousQueries } from "../../api/FAQ/Anonymous";
import { getOrgUserPersonalFaqByOrgUserId } from "../../api/FAQ/PersonalFq/getPersonalQueries";
function Tabs() {
  const [toggleState, setToggleState] = useState(1);
  const auth = useAuthContext();
  const [genralFaq, setGeneralFaq] = useState<any>([]);
  const fetchOrgGenralFaq = async () => {
    await getOrgUserGeneralFaqByOrgUserId(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0].toString()
    )
      .then((e) => {
        console.log(e);
        setGeneralFaq(e);
      })
      .catch((e) => console.log(e));
  };
  const [personalFaq, setPersonalFaq] = useState<any>([]);
  const fetchOrgUserPersonallFaq = async () => {
    await getOrgUserPersonalFaqByOrgUserId(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0].toString()
    )
      .then((e) => {
        console.log(e);
        setPersonalFaq(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrgGenralFaq();
    fetchOrgUserPersonallFaq();
  }, []);
  function toggleTab(index: any) {
    setToggleState(index);
  }
  const handleSelectChnage = (e: any) => {
    const page = e.target.value;
    navigate(`${page}`);
  };
  const navigate = useNavigate();
  console.log(genralFaq);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const handlereateAnonymousFaq = async (e: any) => {
    console.debug("data > ", e);
    await createAnonymousQueries(auth?.userInfo?.orgs[0]?.id, {
      ...e,
    })
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  console.log(auth?.userInfo?.orgs_user_id[0]);
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handlereateAnonymousFaq(e);
    reset();
  };

  return (
    <FaqSc>
      <div className="container">
        <div className="bloc-tabs">
          <button
            className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
            onClick={() => toggleTab(1)}
          >
            Electronic Issues
          </button>
          <button
            className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
            onClick={() => toggleTab(2)}
          >
            Anonymous Queries
          </button>
        </div>

        <div className="content-tabs">
          <div
            className={
              toggleState === 1 ? "content  active-content" : "content"
            }
          >
            <div className="heading-container">
              <h3>General Faq`s</h3>
              <div>
                <select onChange={handleSelectChnage}>
                  <option>Select the queries</option>
                  <option value="/queries/electronicQueries">
                    Electronic Issues
                  </option>
                  <option value="/queries/personalQueries">
                    Personal Issues
                  </option>
                </select>
              </div>
            </div>
            <div>
              <table>
                <tr>
                  <th className="heading">S.no</th>
                  <th className="heading">Type</th>
                  <th className="heading">quest</th>
                  <th className="heading">Applied Date</th>
                </tr>
                {genralFaq?.map((data: any) => {
                  return (
                    <>
                      <tr onClick={() => navigate(`${data?.faq_id}`)}>
                        <td>{data?.faq_id}</td>
                        <td>{data?.faq_type_name}</td>
                        <td>{data?.quest}</td>
                        <td>22-22-2023</td>
                      </tr>
                    </>
                  );
                })}
              </table>
            </div>
            {/* PersonalFaq's */}
            <div className="heading-container">
              <h3>Personal Faq`s</h3>
            </div>
            <div>
              <table>
                <tr>
                  <th className="heading">S.no</th>
                  <th className="heading">quest</th>
                  <th className="heading">Applied Date</th>
                </tr>
                {personalFaq?.map((data: any, idx: any) => {
                  return (
                    <>
                      <tr onClick={() => navigate(`personal/${data?.pq_id}`)}>
                        <td>{idx + 1}</td>

                        <td>{data?.query}</td>
                        <td>{data?.created_at}</td>
                      </tr>
                    </>
                  );
                })}
              </table>
            </div>
          </div>

          <div
            className={
              toggleState === 2 ? "content  active-content" : "content"
            }
          >
            <h3>Share Query As Anonymously</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <select
                className="form-select"
                aria-label="Default select example"
              >
                <option>Select Anonymous</option>
                <option value="1">Anonymous Queries</option>
              </select> */}
              <div className="input-group">
                <span className="input-group-text">
                  Fill the concerns you have
                </span>
                <textarea
                  className="form-control"
                  aria-label="With textarea"
                  {...register("query", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                ></textarea>
              </div>
              <div className="xbi4er-button">
                <button type="submit" className="btn btn-primary">
                  Submit Insytix'er
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </FaqSc>
  );
}

export default Tabs;
